










 

 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewMeetingSettingsToggleTeamHealth_team",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NewMeetingSettingsUpgradeForTeamHealth_team"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node ).hash = "151ff4f2bfb9bf22d55d301aa0f4c00d";

export default node;
